import React, { Component } from 'react';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import { GET_TRANSPORTER_PARTICIPATION } from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import { isAdaniWilmar } from 'Utils/index';


class TransporterParticipationReport extends Component {
    state = {
        isLoading: true
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const user = getUser();
        const companyId = (user && user.companyId) ? user.companyId : '';
        dispatch({
            type: GET_TRANSPORTER_PARTICIPATION,
            params: {
                companyId: companyId,
            }
        });
    }
    showReports = () => {
        const { embedCode, token } = this.props;
        
        return(
            <>
            { this.state.isLoading && <ActionLoader /> }
                {token &&
                    <iframe
                        src={"https://secure.holistics.io/embed/" + embedCode + "?_token=" + token}
                        style={{ width: "100%", height: 600 }}
                        frameBorder="0"
                        title="Transporter Participation"
                        onLoad={() => { this.setState({ isLoading: false }) }}
                        allowFullScreen>
                    </iframe>
                }
            </>
        )
    }
    render() {
        return (
            <>
            {isAdaniWilmar() ? <> {this.showReports()} </> :
            <Sticky hideNavbar={this.props.hideNavbar}>{this.showReports()}</Sticky>}
            </>
        );
    }
}

const mapStateToProps = ({constants}) => {
  return {
    token: constants.holistics.token,
    embedCode: constants.holistics.embedCode,
  }
};


export default connect(mapStateToProps)(TransporterParticipationReport);
